import React from 'react';
import { CreatorHero } from '../components/creator/CreatorHero';
import { CreatorEarnings } from '../components/creator/CreatorEarnings';
import { CreatorHowItWorks } from '../components/creator/CreatorHowItWorks';
import { CreatorCreditsOrCash } from '../components/creator/CreatorCreditsOrCash';
import { CreatorIdeas } from '../components/creator/CreatorIdeas';
import { CreatorDisclose } from '../components/creator/CreatorDisclose';
import { CreatorRules } from '../components/creator/CreatorRules';
import { CreatorFAQ } from '../components/creator/CreatorFAQ';
export function CreatorProgram() {
  return <div className="pt-24 pb-16 bg-[#FAF8F4]" data-id="element-7866" data-mp="1x1jx6ftq5bzx">
      <CreatorHero data-id="element-7867" data-mp="1x3ed1fq52dx5" />
      <CreatorEarnings data-id="element-7868" data-mp="1sav2ysqnu0x3" />
      <CreatorHowItWorks data-id="element-7869" data-mp="1sabhj21swueb" />
      <CreatorCreditsOrCash data-id="element-7870" data-mp="1s90i1efe28t0" />
      <CreatorIdeas data-id="element-7871" data-mp="1s8qmzcfhlbgg" />
      <CreatorDisclose data-id="element-7872" data-mp="14kqwmdm37n2e" />
      <CreatorRules data-id="element-7873" data-mp="14jz4jcrp87gv" />
      <CreatorFAQ data-id="element-7874" data-mp="14jfwqovrizgk" />
    </div>;
}